import React, { Component } from 'react'
import { observer } from 'mobx-react'
import auth, { PRO } from '../../auth'
import CurrentService from '../Common/CurrentService'

/** 旗舰版/尊享版 */
@auth(PRO)
@observer
export default class extends Component {
  render() {
    return <CurrentService />
  }
}
